import {
  CreateTimeSettingsCustomTimeRangeCategoryDocument,
  CreateTimeSettingsCustomTimeRangeCategoryMutationVariables,
  GetTimeSettingsCustomTimeRangeCategoriesDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useCreateCustomTimeRangeCategory = () => {
  const [createCustomTimeRangeCategory, { loading }] = useMutation(
    CreateTimeSettingsCustomTimeRangeCategoryDocument,
    {
      extractorFn: (data) => data.timeSettingsMutations.createTimesettingsCustomTimeRangeCategory,
    }
  )

  const create = (variables: CreateTimeSettingsCustomTimeRangeCategoryMutationVariables) => {
    return createCustomTimeRangeCategory({
      variables,
      refetchQueries: [GetTimeSettingsCustomTimeRangeCategoriesDocument],
    })
  }

  return {
    loading,
    create,
  }
}
